import { QueryParams } from "@/models/query-params.model";
import { Quiz } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, map } from "rxjs";

export class QuizService {
  constructor(
    private _stats = new StatsRest(),
    private _generics = new GenericsUtils()
  ) {}

  private quiz$ = new BehaviorSubject<Quiz>(new Quiz());
  quiz = this.quiz$.asObservable();

  getQuizFromCourse(courseId: string, params?: QueryParams): void {
    this._stats
      .getQuizFromCourse(courseId, params)
      .pipe(
        map((e) => {
          e.content.forEach((item) => {
            if (item.averagePercentage || item.averageTimeSpent) {
              item.averagePercentage = String(item.averagePercentage) ?? " - ";
              item.averageTimeSpent = this._generics.getDurationTime(
                item.averageTimeSpent
              );
            }
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.quiz$.next(response);
        },
      });
  }
}
